import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HomeBlueBanner = () => {
  return (
    <div className="bg-gradient-to-r from-brand-blue-500 to-brand-blue-600 pt-16 pb-8 text-white mb-8 w-full">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="text-center md:text-left mb-6 md:mb-0">
            <h2 className="text-2xl md:text-3xl font-bold mb-2">
              Discover Our Collection
            </h2>
            <p className="text-sm md:text-base opacity-90">
              Explore high-quality products designed just for you.
            </p>
          </div>
          <Link 
            to="/products" 
            className="inline-flex items-center px-6 py-3 bg-white text-brand-blue-500 rounded-lg font-semibold hover:bg-gray-50 transition-colors text-base shadow-md hover:shadow-lg"
          >
            View All Products
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeBlueBanner;